import { ReactPlugin } from '@microsoft/applicationinsights-react-js'
import { ApplicationInsights } from '@microsoft/applicationinsights-web'

export const appInsightsReactPlugin = new ReactPlugin()
export const appInsights = new ApplicationInsights({
    config: {
        connectionString: import.meta.env.VITE_APP_INSIGHTS_CONNECTION_STRING,
        extensions: [appInsightsReactPlugin],
        enableAutoRouteTracking: true,
    },
})
appInsights.addTelemetryInitializer(envelope => {
    envelope.tags ??= []

    envelope.tags['ai.cloud.role'] =
        import.meta.env.VITE_APP_INSIGHTS_CLOUD_ROLE
})

// Only send logs to app insights in non local dev environments.
if (!import.meta.env.DEV) {
    appInsights.loadAppInsights()
}
